module.exports = __webpack_public_path__ + "media/images/nologo-1f65fc338bfe4e1f3a437e83ed3861ee.png";